var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers, withState } from 'recompose';
import { resetPassword } from '../actions';
import logo from '../../../../images/logo.svg';
export var ResetPassword = function (_a) {
    var handleChange = _a.handleChange, handleSubmit = _a.handleSubmit;
    return (_jsxs("form", { onSubmit: handleSubmit, className: "c-inner-wrapper u-max-width-400 u-position-relative u-mt++", children: [_jsx("div", { className: "c-logo-login", children: _jsx("img", { src: logo, alt: "SQUIRE" }) }), _jsx("div", { className: "c-heading-welcome u-text-center u-mv u-pt--", children: "Welcome to Squire!" }), _jsx("div", { className: "c-label-new", children: "Email or username" }), _jsx("input", { className: "c-input c-input--large u-pl-", placeholder: "Email or username", name: "username", onChange: handleChange }), _jsx("div", { className: "o-flexbox u-pt", children: _jsx("button", { type: "submit", className: "c-btn", style: { margin: 'auto' }, children: _jsx("span", { className: "c-btn__text", children: "Send reset link" }) }) })] }));
};
var mapDispatchToProps = {
    resetPassword: resetPassword,
};
export default compose(connect(null, mapDispatchToProps), withRouter, withState('username', 'setUsername', ''), withHandlers({
    handleSubmit: function (props) { return function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var username;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    username = props.username.trim();
                    return [4 /*yield*/, props.resetPassword(username)];
                case 1:
                    _a.sent();
                    props.router.push('/login');
                    return [2 /*return*/];
            }
        });
    }); }; },
    handleChange: function (props) { return function (e) {
        props.setUsername(e.target.value);
    }; },
}))(ResetPassword);
